import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../shared/services/auth.service";
import {MessageService} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {WaitingDialogService} from 'src/app/shared/services/waiting-dialog.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [MessageService],
  standalone: false
})
export class LoginComponent implements OnInit {
  pin = '';
  showPassword = false;
  returnUrl: string = '/home';
  private _isLoginInProgress = false;

  constructor(
    private readonly _router: Router,
    private readonly _route: ActivatedRoute,
    private readonly _authService: AuthService,
    private readonly _waitingDialogService: WaitingDialogService
  ) {
    if (localStorage.getItem('token')) {
      this._authService.isLoggedInSubject.next(true);
    }
  }

  ngOnInit() {
    this._route.queryParams.subscribe(params => {
      if (params['returnUrl']) {
        this.returnUrl = params['returnUrl'];
      }
    });

    this._authService.isLoggedIn$.subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this._router.navigateByUrl(this.returnUrl);
      }
    });
  }

  fieldPress(item: string | number) {
    if (item === 'clear') {
      this.pin = '';

      return;
    }

    if (this.pin.length >= 6) {
      return;
    }

    this.pin += item;

    this.pinChanged();
  }

  onShowPswClear() {
    this.showPassword = !this.showPassword;
  }

  pinChanged() {
    if (this.pin.length !== 6 || this._isLoginInProgress) {
      return;
    }

    this._isLoginInProgress = true;
    this._waitingDialogService.showWaitingDialog(true);

    this._authService.login(this.pin).subscribe(loginSuccessful => {
      this._isLoginInProgress = false;

      if (!loginSuccessful) {
        this.pin = '';
      }
    });
  }
}
